import * as axios from 'axios';
import * as _ from 'lodash';
declare let CRO_APP_API_DOMAIN: string;
declare let initStore: any;
const env:any = initStore.env;


export class DataApi {
    public static loadCategoryData(categoryId) {
        const api_domain = initStore.env.DRS_PRODUCTS_API_BASE;
        const productsApiKey = initStore.env.DRS_PRODUCTS_API_KEY;
        const AxiosConfig = {
            headers: {'x-api-key': productsApiKey}
        };
        return axios
            .get(api_domain+"cr/product-groups/" + categoryId, AxiosConfig)
            .then(response => _.get(response, 'data'))
            .then(productGroup => {
                //console.log('product group: ', productGroup);
                return productGroup;
            }).catch( _.constant(null));
    }
    public static getProductsNew(ids) {
        const api_domain = initStore.env.DRS_PRODUCTS_API_BASE;
        const productsApiKey = initStore.env.DRS_PRODUCTS_API_KEY;
        const AxiosConfig = {
            headers: {'x-api-key': productsApiKey}
        };

        return axios.all(
            ids.map(productId => {
                return axios
                    .get(api_domain+"cr/models/" + productId, AxiosConfig)
                    .then(response => _.get(response, 'data'))
                    .then(product => {
                        return product;
                    }).catch( _.constant(null));
            })
        ).then(
            Newproducts => _.filter(Newproducts, Boolean)
        );

    }

    public static getProducts(ids)  {

        const api_domain = (typeof CRO_APP_API_DOMAIN === "undefined" && typeof initStore !== "undefined") ?
            initStore.products_api_domain :
            CRO_APP_API_DOMAIN;

        return axios.all(
            ids.map(productId => {
                return axios
                    .get(api_domain+"/v0.1/products.(id=" + productId + ").json?numResults=1&prefetch=topref")
                    .then(response => _.get(response, 'data'))
                    .then(_.head)
                    .then(product => {
                        product['ratings'] = product['ratings']
                            .map(rating => _.extend(rating, {
                                    'isTested' : product['isTested'],
                                    'dontBuyType' : product['dontBuyType']
                                })
                            );
                        return product;
                    }).catch( _.constant(null));
            })
        ).then(products => _.filter(products, Boolean));

    }

    public static loadPriceShopData(products)  {

        const shopping_domain = env.SHOPPING_API_DOMAIN;
        const shopping_path = env.SHOPPING_API_PATH;
        const apiKey = env.SHOPPING_API_KEY;

        return axios.all(
            products.map(model =>
                    axios.get(`${shopping_domain}${shopping_path}?categoryId=${model.theCategory.productGroupId}&modelId=${model.id}&include=offers,minPrice,maxPrice,modelId`,
                        { headers: { 'x-api-key': apiKey } }
                    )
                .then(response => _.get(response, 'data.content'))
                .then(_.head)
                .catch(_.constant(null)))
        ).then(priceShop => _.filter(priceShop, Boolean));

    }

    public static loadPriceShopDataNew(products)  {

        const shopping_domain = env.SHOPPING_API_DOMAIN;
        const shopping_path = env.SHOPPING_API_PATH;
        const apiKey = env.SHOPPING_API_KEY;

        return axios.all(
            products.map(model =>
                axios.get(`${shopping_domain}${shopping_path}?categoryId=${model.productGroupHierarchy.categoryId}&modelId=${model._id}`,
                    { headers: { 'x-api-key': apiKey } }
                )
                    .then(response => _.get(response, 'data.content'))
                    .then((content: any[]) => _.map(content, model => Object.assign(model, this.findMinMaxPrice(model))))
                    .then(_.head)
                    .catch(_.constant(null)))
        ).then(priceShop => _.filter(priceShop, Boolean));

    }

    private static findMinMaxPrice(model) {
        return model.offers.reduce((acc, prAndShop) => {
            acc.minPrice = _.min([acc.minPrice, prAndShop.price]);
            acc.maxPrice = _.max([acc.maxPrice, prAndShop.price]);
            return acc;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/product-compare/components/DataApi.tsx